// @flow

import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import ZoomTable from "../../../../commons/zoomTable/zoomTable";
import styles from "./categoryDetails.scss";
import Loader from "../../../../commons/loader/loader";

type Props = {
  userProfile: Object,
  category: Object,
  categorySettingsState: Object,
  onEditCategory: Function,
  onEditIssue: Function,
  onDeleteIssue: Function,
  createIssue: Function
};

type State = {
  buName: String
};

class CategoryDetails extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      buName:
        this.props.userProfile.business_unit &&
        this.props.userProfile.business_unit.unitName
    };
    this.tableActionFunctions = {
      editTicketType: rowData => {
        this.props.onEditIssue(rowData);
      },
      deleteTicketType: rowData => {
        /* eslint-disable no-console */
        console.log("Delete ticket type", rowData);
        /* eslint-enable no-console */
        if (rowData && !rowData.isActive) {
          toastr.error("This ticket type is already inactive.");
        } else {
          this.props.onDeleteIssue(rowData);
        }
      }
    };
  }

  renderCreateIssueTypeButton() {
    return (
      <div
        className={styles.createIssueButton}
        onClick={() => this.props.createIssue()}
      >
        <div className={styles.createIssueText}>+ Create new issue type</div>
      </div>
    );
  }

  renderHeading() {
    return (
      <div className={`${styles.categoryHeading}`}>
        {this.props.category.name.charAt(0).toUpperCase() +
          this.props.category.name.slice(1).toLowerCase()}{" "}
        Issue Types
      </div>
    );
  }

  renderTable() {
    return (
      <div className={styles.issueTypesTableWrapper}>
        <ZoomTable
          configKey="CATEGORY_DETAILS_KEY"
          tableData={this.props.categorySettingsState.ticketTypes.data || []}
          tableDataLength={
            (this.props.categorySettingsState.ticketTypes.data &&
              this.props.categorySettingsState.ticketTypes.data.length) ||
            0
          }
          actionFunctions={this.tableActionFunctions}
        />
      </div>
    );
  }

  render() {
    const { ticketTypes } = this.props.categorySettingsState;
    // eslint-disable-next-line
    console.log(this.state.buName);
    if (ticketTypes.isLoaded) {
      return (
        <div className={styles.categoryDetailsWrapper}>
          <div className="l-row j-space-bet a-center">
            {this.renderHeading()}
          </div>
          {this.renderCreateIssueTypeButton()}
          {this.renderTable()}
        </div>
      );
    }
    return <Loader />;
  }
}

const mapStateToProps = state => ({
  userProfile: state.userProfile,
  categorySettingsState: state.categorySettingsState
});

export default connect(mapStateToProps, null)(CategoryDetails);



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/categorySettings/categoryDetails/categoryDetails.js